export const VALIDATORS = {
  olderThan: (years) => (value) => {
    const date = new Date(value);
    const now = new Date();
    const diff = now.getFullYear() - date.getFullYear();
    return diff >= years;
  },
  youngerThan: (years) => (value) => {
    const date = new Date(value);
    const now = new Date();
    const diff = now.getFullYear() - date.getFullYear();
    return diff <= years;
  },
  valid: (value) => {
    const [month, day, year] = value.split("/");
    const date = new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
    return (
      date.getFullYear() === parseInt(year) &&
      date.getMonth() === parseInt(month) - 1 &&
      date.getDate() === parseInt(day)
    );
  },
  validState: (value) => {
    const states = [
      "AL",
      "AK",
      "AZ",
      "AR",
      "CA",
      "CO",
      "CT",
      "DE",
      "FL",
      "GA",
      "HI",
      "ID",
      "IL",
      "IN",
      "IA",
      "KS",
      "KY",
      "LA",
      "ME",
      "MD",
      "MA",
      "MI",
      "MN",
      "MS",
      "MO",
      "MT",
      "NE",
      "NV",
      "NH",
      "NJ",
      "NM",
      "NY",
      "NC",
      "ND",
      "OH",
      "OK",
      "OR",
      "PA",
      "RI",
      "SC",
      "SD",
      "TN",
      "TX",
      "UT",
      "VT",
      "VA",
      "WA",
      "WV",
      "WI",
      "WY",
    ];
    return states.includes(value.toUpperCase());
  },
  length: (length) => (value) => value.length === length,
  required: (value) => value.length > 0,
  maskRequired: (maskChar) => (value) => value.indexOf(maskChar) < 0
};
